<template>
    <v-container fluid>
        <v-row class="mb-2">
            <v-col cols="6">
                <v-btn-back @click="endAnalysis"> </v-btn-back>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
                <v-btn
                    rounded
                    elevation="0"
                    @click="groupAnalysis"
                    :disabled="disabledGroup"
                    size="small"
                >
                    Regrouper
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="companies">
            <v-col>
                <v-card class="rounded-lg" height="80vh" elevation="0">
                    <v-row>
                        <v-col>
                            <v-card-title>
                                <h4>Analyse des SIREN</h4>
                            </v-card-title>
                        </v-col>
                        <v-card-actions>
                            <v-col class="d-flex justify-end">
                                <v-btn-prev @click="idx--" size="small" />
                                <span style="white-space: nowrap"> {{ idx }}/{{ total }} </span>
                                <v-btn-next @click="idx++" size="small" />
                            </v-col>
                        </v-card-actions>
                    </v-row>
                    <v-row class="ma-2">
                        <v-col>
                            <v-btn
                                rounded
                                elevation="0"
                                class="mr-2 mt-1"
                                @click="selectAll"
                                size="small"
                            >
                                Tout sélectionner
                            </v-btn>
                            <v-btn
                                outlined
                                rounded
                                elevation="0"
                                class="ml-2 mt-1"
                                @click="clearAll"
                                size="small"
                            >
                                Tout désélectionner
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="5">
                            <div v-for="(item, index) in companies.analysis" :key="index">
                                <v-card
                                    class="ml-2 rounded-lg"
                                    height="58vh"
                                    elevation="0"
                                    v-if="idx - 1 === index"
                                    outlined
                                >
                                    <v-list-item
                                        v-for="itm in item"
                                        :key="itm.id"
                                        class="oss-list-item ma-1"
                                    >
                                        <template v-slot:append>
                                            <v-checkbox v-model="currentCompanies" :value="itm">
                                            </v-checkbox>
                                        </template>
                                        <v-list-item-title
                                            style="text-overflow: ellipsis; max-width: 600px"
                                        >
                                            {{ getFullCompanyName(itm) }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>{{ itm.siret }}</v-list-item-subtitle>
                                        <v-list-item-subtitle>{{
                                            itm.groupKey
                                        }}</v-list-item-subtitle>
                                        <div class="body-2">{{ itm.address }} {{ itm.city }}</div>
                                    </v-list-item>
                                </v-card>
                            </div>
                        </v-col>
                        <v-col cols="2" class="d-flex justify-center">
                            <v-icon size="x-large">$keyboard_tab</v-icon>
                        </v-col>
                        <v-col cols="5">
                            <v-card class="mr-2 rounded-lg" height="58vh" elevation="0" outlined>
                                <v-list-item
                                    v-for="itm in currentCompanies"
                                    :key="itm.id"
                                    class="ma-1"
                                >
                                    <v-list-item-title
                                        style="text-overflow: ellipsis; max-width: 600px"
                                    >
                                        {{ getFullCompanyName(itm) }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{ itm.siret }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>{{ itm.groupKey }}</v-list-item-subtitle>
                                    <div class="body-2">{{ itm.address }} {{ itm.city }}</div>
                                </v-list-item>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import COMPANIES_SIREN from "../graphql/company/CompaniesSiren.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["analysis-done", "group-done"],
})
export class GroupKeyAnalysis extends Vue {
    total = 0;
    idx = 1;
    currentCompanies = [];

    @Apollo({
        query: COMPANIES_SIREN,
        /* variables() {
            return {
                first:  1,
                skip: this.index
            }
        }, */
        result({ data, loading, networkStatus }: any) {
            if (data) {
                this.companies = JSON.parse(JSON.stringify(data.groupKeyAnalysis));
                this.total = this.companies.analysis.length;
            } else {
                this.companies = null;
            }
        },
    })
    companies: any = null;

    @Watch("idx")
    indexManager() {
        if (this.idx > this.total) {
            this.idx = 1;
        }
        if (this.idx < 1) {
            this.idx = this.total;
        }
        this.currentCompanies = [];
    }

    endAnalysis() {
        this.$emit("analysis-done");
    }

    get disabledGroup() {
        if (this.currentCompanies.length > 1) {
            return false;
        }
        return true;
    }

    selectAll() {
        this.currentCompanies = this.companies.analysis[this.idx - 1];
    }

    clearAll() {
        this.currentCompanies = [];
    }

    groupAnalysis() {
        this.$emit("group-done", { currentCompanies: this.currentCompanies });
    }

    getFullCompanyName(company) {
        let name = company.name;
        if (company.legalUnitName && company.legalUnitName !== name) {
            name += " (" + company.legalUnitName + ")";
        }
        if (company.tradeName && company.tradeName !== name) {
            name += " (" + company.tradeName + ")";
        }
        if (company.shortname && company.shortname !== name) {
            name += " (" + company.shortName + ")";
        }
        return name;
    }
}

export default toNative(GroupKeyAnalysis);
</script>
